import MuiCheckbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { UNIT, mainColor } from '../../constants';

const CustomCheckbox = withStyles(() => ({
  root: {
    paddingRight: UNIT * 0.625,
    marginLeft: -UNIT * 0.625
  },
  checked: {
    color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1) !important`
  }
}))(MuiCheckbox);

const Checkbox = props => {
  const { onClick, value = false, name, text, className, disabled, hidden } = props;
  return (
    <div
      role='button'
      tabIndex={0}
      style={{ height: UNIT * 2.18, paddingTop: UNIT * 0.625 }}
      className={` w-100 align-items-center  ${className} ${hidden ? 'd-none' : 'd-flex'}`}
      onClick={onClick}
      onKeyPress={onClick}
      id={name}
    >
      <CustomCheckbox checked={value} value={value} id={name} name={name} disabled={disabled} />
      <div style={{ textAlign: 'left' }} id={name}>
        {text}
      </div>
    </div>
  );
};
export default Checkbox;
